// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_jM9","cls2":"UpsellModalRedesign-cls2_g2Y UpsellModalRedesign-cls1_jM9"};